import { FC, useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import theme from "@/theme";
import { useTopLeaderboardQuery } from "@/store/api/leaderboardApi";
import { useLocation, useNavigate } from "react-router-dom";
import { stylesTrendingUser as styles } from "./stylesTrendingUser";
import CustomSelect from "@/components/UI/CustomSelect/CustomSelect";
import CustomLoader from "@/components/UI/CustomLoader/CustomLoader";
import { formatLikesCount } from "@/helpers/formatCount";

interface ITrendingUserProps {
  filterTimeTrendingUsers: string;
  setFilterTimeTrendingUsers: (value: string) => void;
}
const LIMIT = 3;
const TrendingUser: FC<ITrendingUserProps> = ({
  filterTimeTrendingUsers,
  setFilterTimeTrendingUsers,
}) => {
  const [sortBy, setSortBy] = useState({});
  const location = useLocation();
  const symbol = useMemo(() => {
    const match = location.pathname.match(/\/stock\/([^/]+)/);
    return match ? match[1] : "";
  }, [location.pathname]);
  useEffect(() => {
    setSortBy({
      page: 1,
      limit: LIMIT,
      sortBy: "likes",
      timeframe:
        filterTimeTrendingUsers === ""
          ? "1_week"
          : filterTimeTrendingUsers === "All time"
            ? "all_time"
            : filterTimeTrendingUsers.replace(" ", "_"),
      ...(symbol && { symbol }),
    });
  }, [filterTimeTrendingUsers, symbol]);
  const { data, isFetching } = useTopLeaderboardQuery(
    { ...sortBy },
    {
      // pollingInterval: 5000,
    }
  );
  const navigate = useNavigate();
  const timeOptions = ["1 day", "1 week", "1 month", "1 year", "All time"];
  const handleShowMoreClick = () => {
    navigate("/leaderboard");
  };
  return (
    <Box sx={styles.wrapperTrendingUsers}>
      <Box sx={styles.headerTrendingUsers}>
        <Typography
          variant="subtitle2"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "24px",
            letterSpacing: "0%",

            color: "text.primary",
          }}
        >
          Trending Users
        </Typography>

        <CustomSelect
          placeholder="1 week"
          options={timeOptions}
          selected={filterTimeTrendingUsers ? [filterTimeTrendingUsers] : []}
          onChange={(value) => setFilterTimeTrendingUsers(value[0])}
          checkblack
          multiple={false}
          width="145px"
          height="36px"
          defaultBG="#fff"
        />
      </Box>

      <TableContainer sx={styles.tableContainer}>
        <Box sx={styles.tableWrapper}>
          {/* <RequireAuth> */}
          <Table sx={{ width: "100%" }}>
            {isFetching ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: LIMIT * 52,
                  position: "relative",
                  filter: "none",
                }}
              >
                <CustomLoader loading size={48} />
              </Box>
            ) : (
              <TableBody sx={{ ...styles.tableBody, minHeight: LIMIT * 52 }}>
                {data?.users?.map((row: any, index: number) => (
                  <TableRow key={row.username} sx={styles.tableRow}>
                    <TableCell sx={styles.tableCellw}>
                      <Typography
                        variant="h6"
                        fontWeight={500}
                        color={theme.palette.custom.blueGray900}
                        marginRight={"10px"}
                      >
                        {index + 1}
                      </Typography>
                    </TableCell>
                    <TableCell sx={styles.tableCellw}>
                      <Box sx={styles.usernameRow} onClick={() => navigate(`/profile/${row?.uid}`)}>
                        <Avatar
                          src={row?.image?.url}
                          alt="Profile"
                          sx={{ width: 36, height: 36 }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "36px",
                            gap: "4px",
                          }}
                        >
                          <Typography variant="h6" sx={styles.userName}>
                            {row?.username}
                          </Typography>
                          <Typography sx={styles.userLikes}>
                            {formatLikesCount(row.totalLikes)} likes
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
          {/* </RequireAuth> */}
        </Box>
        <Box
          sx={{
            width: "304px",
            height: "42px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            opacity: 1,
            transform: "rotate(0deg)",
            cursor: "pointer",
          }}
          onClick={handleShowMoreClick}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "15px",
              lineHeight: "100%",
              letterSpacing: "0%",
              color: theme.palette.custom.mainBlue,
            }}
          >
            Show more
          </Typography>
        </Box>
      </TableContainer>
    </Box>
  );
};

export default TrendingUser;
